import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import classNames from 'classnames';
import StyledLabel from '../styled-label';
import { Icon } from '@vpp-frontend-components/icon';
import { generateKeyToComponent } from '../../utils/validators';

const namespace = 'ui-pdp-sales-terms-short-description';

const SalesTermsShortDescription = ({ state, className, benefits }) => {
  if (state == null || state === 'HIDDEN') {
    return null;
  }

  return (
    <div className={classNames(`${namespace}__container`, className)}>
      {benefits?.map(subtitle => (
        <div key={generateKeyToComponent(subtitle)} className={`${namespace}__subtitle-container`}>
          {subtitle.icon && <Icon className={`${namespace}__info-icon`} {...subtitle.icon} />}
          <StyledLabel className={`${namespace}__subtitle`} {...subtitle} />
        </div>
      ))}
    </div>
  );
};

SalesTermsShortDescription.propTypes = {
  state: string,
  className: string,
  benefits: arrayOf(shape({})),
};

SalesTermsShortDescription.defaultProps = {
  className: '',
};

export default SalesTermsShortDescription;
